var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"button outline primary text-reader"},[_vm._v("Subir CSV "),_c('input',{ref:"inputFile",staticClass:"button transparent",attrs:{"type":"file","accept":".csv"},on:{"change":_vm.loadTextFromFile}})])])}
var staticRenderFns = []

export { render, staticRenderFns }